"use client";

import ItemCard from "./ItemCard";

export default function ItemCardsBlock({ slice }) {
  return (
    <div className="lg:max-w-[730px] grid grid-cols-1 sm:grid-cols-2 sm:[&>div:nth-last-child(2)]:border-b-0 mx-auto">
      {slice.primary.feature_items.map((item, idx) => {
        return <ItemCard key={`feature_2_${idx}`} data={item} />;
      })}
    </div>
  );
}
